/**
 * MyCopro - Offline Banner
 * Bandeau persistant affiché en haut de l'écran quand l'appareil est hors connexion
 */

import React from 'react';
import { WifiOff } from 'lucide-react';
import { useNetworkStatus } from '@/hooks/useNetworkStatus';

export const OfflineBanner: React.FC = () => {
  const { isOnline } = useNetworkStatus();

  if (isOnline) {
    return null;
  }

  return (
    <div className="bg-gray-700 text-white px-4 py-2">
      <div className="flex items-center justify-center gap-2 max-w-screen-xl mx-auto">
        <WifiOff size={16} />
        <span className="font-medium text-sm text-center">
          Hors connexion — données non actualisées
        </span>
      </div>
    </div>
  );
};

export default OfflineBanner;
